import {StyleProp, StyleSheet, TextStyle} from 'react-native';
import {
  useColorThemeType,
  useFontTheme,
} from '../../../../src/appStyles/hooks/theme';

import {Box} from '../../../components/core/view';
import {H3Text} from '../../../components/core/text';
import React from 'react';

interface DriverScreenHeaderProps {
  title: string;
  titleStyle?: StyleProp<TextStyle>;
}

const ScreenHeader: React.FC<DriverScreenHeaderProps> = props => {
  const theme = useColorThemeType('main');
  const muli = useFontTheme('muli');
  const title = props?.title || '';
  return (
    <Box style={styles.headerBox}>
      <H3Text
        style={[
          {
            color: theme?.text?.blue[300],
            fontFamily: muli?.[700]?.normal,
          },
          props.titleStyle,
        ]}>
        {title}
      </H3Text>
    </Box>
  );
};

export default React.memo(ScreenHeader);
const styles = StyleSheet.create({
  headerBox: {
    flexDirection: 'row',
    marginBottom: 10,
    marginTop: -36,
    alignSelf: 'center',
  },
});
